import React from "react";
import { useParams } from "react-router";
import Form from "../components/Form/Form";
import { useGetTaskQuery } from "../features/tasks/taskAPI";
function Edit() {
  const { id } = useParams();

  const { data: formData, isLoading, isError } = useGetTaskQuery(id);

  let outputForm = null;
  if (!isLoading && isError) outputForm = "Something Went Wrong!";
  if (!isLoading && !isError) outputForm = <Form initialData={formData} />;

  return (
    <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Update Task for Your Team
        </h1>

        {outputForm}
      </main>
    </div>
  );
}

export default Edit;
